"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrapper =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "ez1mtsr0"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _objectSpread2.default)({
    margin: '0 0 10px',
    display: 'flex'
  }, theme.brand);
});
var HeadingLink =
/*#__PURE__*/
(0, _styled.default)("a", {
  target: "ez1mtsr1"
})({
  textDecoration: 'none',
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid rgba(0, 0, 0, 0.1)',
  borderRadius: 2,
  textTransform: 'uppercase',
  letterSpacing: '1.5px',
  fontSize: '12px',
  fontWeight: 'bolder',
  color: 'currentColor',
  textAlign: 'center',
  cursor: 'pointer',
  padding: '5px',
  margin: 0,
  overflow: 'hidden'
});
var ShortHelpButton =
/*#__PURE__*/
(0, _styled.default)("button", {
  target: "ez1mtsr2"
})({
  textTransform: 'uppercase',
  fontSize: 12,
  fontWeight: 'bolder',
  color: 'currentColor',
  border: '1px solid rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  borderRadius: 2,
  cursor: 'pointer',
  display: 'inlineBlock',
  padding: 0,
  margin: '0 0 0 5px',
  backgroundColor: 'inherit',
  outline: 0,
  width: 30,
  flexShrink: 0
});

var Header = function Header(_ref2) {
  var openShortcutsHelp = _ref2.openShortcutsHelp,
      name = _ref2.name,
      url = _ref2.url,
      enableShortcutsHelp = _ref2.enableShortcutsHelp,
      isMobileDevice = _ref2.isMobileDevice;
  return _react.default.createElement(Wrapper, {
    isMobileDevice: isMobileDevice
  }, _react.default.createElement(HeadingLink, {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, name), enableShortcutsHelp && _react.default.createElement(ShortHelpButton, {
    onClick: openShortcutsHelp
  }, "\u2318"));
};

Header.defaultProps = {
  openShortcutsHelp: null,
  enableShortcutsHelp: true,
  name: '',
  url: '',
  isMobileDevice: false
};
Header.propTypes = {
  openShortcutsHelp: _propTypes.default.func,
  name: _propTypes.default.string,
  url: _propTypes.default.string,
  isMobileDevice: _propTypes.default.bool,
  enableShortcutsHelp: _propTypes.default.bool
};
var _default = Header;
exports.default = _default;